import type { HomePageData } from '@cng/shared';
import { useSite } from '@/app/page-data';
import { SectionContainer } from '@/components/layout/SectionContainer';
import { Ticker } from '@/components/home/Ticker';
import { Hero } from '@/components/home/Hero';
import { CuratedServices } from '@/components/home/CuratedServices';
import { ComboOffers } from '@/components/home/ComboOffers';
import { Transformations } from '@/components/home/Transformations';
import { FeaturedWork } from '@/components/home/FeaturedWork';
import { PrepaidPackages } from '@/components/packages/PrepaidPackages';
import { ServicePills } from '@/components/home/ServicePills';
import { Link } from 'react-router-dom';
import { LocationsSection } from '@/components/locations/LocationsSection';

/**
 * The homepage in the section order of the live site, each block wrapped in the
 * same container shape Elementor gives it there (see SectionContainer).
 *
 * Every section reads its copy, imagery and enabled flag from the homepage
 * configuration document, so the owner can reword or switch one off without a
 * deploy.
 */
export function HomePage({ data }: { data: HomePageData & { kind: 'home' } }) {
  const { settings, branches } = useSite();
  const { homepage, offers, packages, transformations, featuredWork } = data;

  if (!homepage) return null;

  return (
    <>
      <SectionContainer variant="full">
        <div className="cg9">
          <Ticker config={homepage.ticker} />
          <Hero hero={homepage.hero} />
        </div>
      </SectionContainer>

      <SectionContainer>
        <CuratedServices config={homepage.curatedServices} />
      </SectionContainer>


      <SectionContainer>
        <Transformations
          config={homepage.transformations}
          items={transformations}
          settings={settings}
        />
      </SectionContainer>

      <SectionContainer>
        <FeaturedWork config={homepage.featuredWork} items={featuredWork} />
      </SectionContainer>

      <SectionContainer>
        <LocationsSection config={homepage.locations} branches={branches} settings={settings} />
      </SectionContainer>

      <SectionContainer variant="full">
        <ComboOffers config={homepage.comboOffers} offers={offers} settings={settings} />
      </SectionContainer>

      {/* The live page nudges this container up by 3px to close a seam. */}
      <SectionContainer variant="full" style={{ marginTop: '-3px' }}>
        <PrepaidPackages config={homepage.packages} items={packages} settings={settings} />
      </SectionContainer>

      <SectionContainer>
        <ServicePills config={homepage.servicePills} />
      </SectionContainer>

      <SectionContainer>
        <p className="gallery-link"><Link to="/charlie-guys-gallery/">Browse our salon gallery ?</Link></p>
      </SectionContainer>

    </>
  );
}
